import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./index.css";
import CalendarPicker from "rc-calendar";
import axios from 'axios'
import search_icon from "../../../assets/images/search.svg";
import close_icon from "../../../assets/images/close.png";
import filter_icon from "../../../assets/images/filter.png";
import close_circle from "../../../assets/images/close-circle.png";
import close_x from "../../../assets/images/close-x.png";
import right_arrow from "../../../assets/images/right-arrow.svg";
import down_arrow from "../../../assets/images/arrow-down.svg";
import print_icon from "../../../assets/images/printer.svg";
import $ from 'jquery';
import DatePicker from "react-datepicker";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon
} from 'react-share';
class View_type_25 extends Component {
    constructor(props) {
        super(props);
        let data = { events: [], ...props.data };

        this.state = {
            data: data,
            width: 0,
            height: 0,
            isVisible: true,
            counter: data.items_per_page ? data.items_per_page : null,
            counterSecond: 0,
            options: {
                margin: 3,
                dots: false,
                nav: true,
                touchDrag: false,
                mouseDrag: false,
                startPosition: data.start_day ? data.calendar.findIndex((month) => month.month === `${data.start_day.split("-")[1]}.${data.start_day.split("-")[2]}`) : 0,
                animateIn: 'flipInX',
                responsive: {
                    0: {
                        items: 1,
                    },
                    400: {
                        items: 1,
                    },
                    600: {
                        items: 1,
                    },
                    750: {
                        items: 1,
                    },
                    1000: {
                        items: 1,
                    },
                },
            }
        };
        //console.log("View_type_25: ", this.state);
        //console.log("View_type_25 config:", this.props.config.gbcolor)
        // this.submitHandler = this.submitHandler.bind(this)
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const searchParam = urlParams.get('search');

        if (searchParam) {
            document.getElementById("singleInput").value = searchParam;
            document.getElementById("search-btn").classList.add("active");
            document.getElementById("singleInput").classList.add("slided");
            this.submitHandler(null, searchParam);
        }

        document.addEventListener("keypress", this.submitHandler);
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    // componentWillUnmount() {
    //     document.removeEventListener("keypress", this.submitHandler);
    //     window.removeEventListener("resize", this.updateWindowDimensions);
    // }

    updateWindowDimensions() {
        this.setState(() => {
            return {
                width: window.innerWidth,
                heigth: window.innerHeight
            };
        });
    }

    submitHandler(event, searchParam = null) {
        if (event && event.keyCode === 13) {
            event.preventDefault();
            const inputText = document.getElementById("singleInput").value;
            searchParam = inputText;
        }

        if (searchParam) {
            $(".event-box").each(function () {
                $(this).text().toLowerCase().indexOf(searchParam.toLowerCase()) > -1 ? $(this).show() : $(this).hide();
            });
        }

        $(".fixed-search-container").fadeOut();

        const params = new URLSearchParams();
        params.set("search", searchParam);

        window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
    }

    calendarRow() {
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        let result = [];
        var i = date;
        for (i; i < 32; i++) {
            result.push(<div className="item day-box">{i}</div>);
        }
        return result;
    }

    showSearch = (e) => {
        const searchButton = e.currentTarget;

        // Sprawdzamy, czy klasa active jest usuwana
        if (searchButton.classList.contains("active")) {
            // Jeśli klasa active była, usuwamy parametry z URL
            const url = new URL(window.location);
            url.searchParams.delete("search"); // Usunięcie parametru "search"

            // Aktualizacja URL bez przeładowania strony
            window.history.replaceState({}, '', url);
        }

        // Przełączanie widoczności event-box
        document.querySelectorAll(".event-box").forEach(function (e) {
            e.style.display = "block";
        });

        // Przełączanie klas
        $("#singleInput").toggleClass("slided");
        $("#search-btn").toggleClass("active");

        // Skupienie na polu wejściowym
        $("#singleInput").focus();
    }

    hideSearch = () => {
        $(".fixed-search-container").fadeOut(300);
    }

    showFilter = () => {
        $(".filter-window").slideToggle(300);
    }

    closeFilter = () => {
        $(".filter-window").slideUp(300);
    }

    printDoc = () => {
        window.print();
    }

    render() {

        let currentSelection = [];

        const updateEvents = () => {
            if (currentSelection.length < 1) {
                document.querySelectorAll(".event-box").forEach(function (e) {
                    e.style.display = "block"
                })
            } else {
                document.querySelectorAll(".event-box").forEach(function (e) {
                    e.style.display = "none"
                })
                currentSelection.forEach(function (e) {
                    document.querySelectorAll(`.type-${e}`).forEach(function (f) {
                        f.style.display = "block";
                    })
                })
            }
        }

        const placeFilter = (id, event) => {
            event.currentTarget.classList.toggle("removed");
            document.querySelectorAll(`.place-${id}`).forEach(function (item) {
                item.classList.toggle("removed");
            })
        }

        const markEvent = (e) => {
            const item = e.currentTarget;
            let color = item.getAttribute("color");
            let id = item.getAttribute("order");
            item.classList.toggle("selected");
            item.classList.value.indexOf("selected") > -1 ? (
                item.style.backgroundColor = color,
                currentSelection.push(id),
                updateEvents()
            ) : (
                item.style.backgroundColor = "white",
                currentSelection.splice(currentSelection.indexOf(id), 1),
                updateEvents()
            );
        }

        const mainColor = this.props.config.gbcolor;

        const searchIcon = <svg xmlns="http://www.w3.org/2000/svg" fill={`#${mainColor}`} width="32.224" height="32.2" viewBox="0 0 32.224 32.2"><defs></defs><path class="a" d="M33.751,31.464l-5.974-5.926a14.492,14.492,0,1,0-2.238,2.238L31.464,33.7a1.6,1.6,0,1,0,2.287-2.238ZM16.505,27.777A11.272,11.272,0,1,1,27.777,16.505,11.272,11.272,0,0,1,16.505,27.777Z" transform="translate(-1.979 -1.979)" /></svg>

        // document.addEventListener("keypress", function submitHandler(event) {
        //     if (event.keyCode === 13) {
        //         event.preventDefault();

        //         const inputText = document.getElementById("singleInput").value;

        //         $(".event-box").each(function () {
        //             $(this).text().toLowerCase().indexOf(inputText.toLowerCase()) > -1 ? $(this).show() : $(this).hide();
        //         });

        //         $(".fixed-search-container").fadeOut();

        //         const params = new URLSearchParams();
        //         params.set("search", inputText);

        //         window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
        //     }
        // });

        var object = this.props.data;
        var title = this.state.data.title;
        var expand = this.state.data.expand;
        var collapse = this.state.data.collapse;
        var performers = this.state.data.performers;
        var program = this.state.data.program;
        let filter_label = window.location.href.indexOf("/en/") > -1 ? "Filter" : "Filtruj";
        const firstEvent = this.state.data.events[0];
        //console.log(firstEvent, 'firstEvent');
        let shareLabel1 = window.location.href.indexOf("/en/") > -1 ? "Program - Festival Chopin and His Europe" : "Program - Festiwal Chopin i Jego Europa";
        let shareLabel2 = window.location.href.indexOf("/en/") > -1 ? "16th International Music Festival" : "XVI Międzynarodowy Festiwal Muzyczny";
        let listUrl = JSON.stringify({ title: shareLabel1, image: firstEvent !== undefined ? firstEvent.image : '', text: shareLabel2 });
        //console.log(listUrl, 'listUrl');
        let readyListUrl = btoa(unescape(encodeURIComponent(listUrl)))

        function scrollRight() {
            var dayWidth = document.querySelector(".days-list").offsetWidth / 2;
            document.querySelector(".days-list").scrollBy({ left: dayWidth, behavior: "smooth" })
        }
        function scrollLeft() {
            var dayWidth = document.querySelector(".days-list").offsetWidth / 2;
            document.querySelector(".days-list").scrollBy({ left: -dayWidth, behavior: "smooth" })
        }

        function showDescription(e) {
            $(e.target).toggleClass("expanded");
            if ($(e.target).hasClass("expanded")) {
                $(e.target).text(collapse);
            }
            else {
                $(e.target).text(expand);
            }
            var open = e.target.closest(".event-description");
            $(open).toggleClass("opened");
        }
        $(".vt25 .events-container .event-description .event-info").each(function () {
            if ($(this).height() > 200) {
                $(this).addClass("to-expand");
                $(this).closest(".event-description").addClass("event-to-expand");
            }
        });
        $(".vt25 .events-container .event-description .artists").each(function () {
            if ($(this).height() > 192) {
                $(this).addClass("to-expand");
                $(this).closest(".event-description").addClass("event-to-expand");
            }
        });
        $(".vt25 .events-container .event-description .program").each(function () {
            if ($(this).height() > 195) {
                $(this).addClass("to-expand");
                $(this).closest(".event-description").addClass("event-to-expand");
            }
        });
        $(".vt25 .events-container .event-description").each(function () {
            var description = $(this).find(".scrolled.description")
            if (!$(description).is(":empty")) {
                $(this).addClass("to-expand");
                $(this).closest(".event-description").addClass("event-to-expand");
            }
        });
        $('.vt25 .events-container .event-description .description p').each(function () {
            var $p = $(this),
                txt = $p.html();
            if (txt == '&nbsp;') {
                $p.remove();
            }
        });

        (function () {
            let minHeight = $(".filter-window").height();
            $(".filter-window").hide();
            $(".vt25-wrapper").css("min-height", minHeight + 105);
        })()

        function selectMonth(date) {

            date = date.split('.')[0]

            if (date[0] === "0") {
                date = date[1]
            }

            const months = {
                "pl": ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
                "en": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"]
            };

            const lang = window.location.pathname.split('/')[1]

            //console.log(date)
            return months[lang][parseInt(date) - 1]
        }

        return (
            <div className="vt25 vt25-wrapper">

                <div className="title-search">
                    <h1>{title} {this.state.data.calendar_year}</h1>
                    <div>
                        <button id="print-btn" onClick={this.printDoc} style={{ backgroundImage: `url(${print_icon})` }}></button>
                        <div className="vt25-search-wrapper">
                            <form id="event-search">
                                <input id="singleInput" type="text" name="value"></input>
                            </form>
                            <button id="search-btn" onClick={this.showSearch}>
                                {searchIcon}
                            </button>
                        </div>
                        <div className="share-section">
                            <FacebookShareButton url={window.location.href + "?media=" + readyListUrl}>
                                <FacebookIcon size={35} />
                            </FacebookShareButton>

                            <TwitterShareButton url={window.location.href + "?media=" + readyListUrl}>
                                <TwitterIcon size={35} />
                            </TwitterShareButton>

                            <LinkedinShareButton url={window.location.href + "?media=" + readyListUrl}>
                                <LinkedinIcon size={35} />
                            </LinkedinShareButton>
                        </div>
                    </div>
                </div>

                <div className="filter-section" style={{ backgroundImage: `url(${filter_icon})` }}>
                    <p onClick={this.showFilter}>{filter_label}</p>
                    <div className="filter-window">
                        <div className="row">
                            <div className="col-md-12">
                                <button id="close-filter" onClick={this.closeFilter} style={{ backgroundImage: `url(${close_x})` }}></button>
                            </div>

                            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                {this.state.data.label_types}
                                <div className="type-select">
                                    {Array.isArray(this.state.data.events) && this.state.data.events.length > 0 ? (
                                        this.state.data.events.map((event, eventIndex) => (
                                            Array.isArray(event.types) && event.types.length > 0 ? (
                                                event.types.map((item, index) => {
                                                    let color = item.type_color ? item.type_color : "black";
                                                    return (
                                                        <div onClick={markEvent} key={`${eventIndex}-${index}`} order={item.id_type} color={color} className="box" style={{ borderColor: color, color: color }}>
                                                            {item.type ? item.type : item}
                                                            <svg style={{ fill: color }} xmlns="http://www.w3.org/2000/svg" width="24.656" height="24.656" viewBox="0 0 24.656 24.656">
                                                                <path d="M11.951,5.483a.872.872,0,0,0-1.238,0l-2,2-2-2A.875.875,0,0,0,5.483,6.721l2,2-2,2a.875.875,0,1,0,1.238,1.238l2-2,2,2a.875.875,0,1,0,1.238-1.238l-2-2,2-2a.872.872,0,0,0,0-1.238Zm2.929-2.929a8.717,8.717,0,1,0,0,12.328,8.715,8.715,0,0,0,0-12.328Zm-1.229,11.1a6.974,6.974,0,1,1,2.04-4.934A6.974,6.974,0,0,1,13.651,13.651Z"
                                                                    transform="translate(0 12.328) rotate(-45)" />
                                                            </svg>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                null
                                            )
                                        ))
                                    ) : (
                                        null
                                    )}
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                {this.state.data.label_places}
                                <div className="place-select" >
                                    {this.state.data.places.map(function (item, index) {
                                        return (
                                            <div key={index} order={item.id} style={{ backgroundColor: `#${mainColor}` }} className="box" onClick={placeFilter.bind(null, item.id)}>
                                                {item.name}
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="calendar-row">
                    {this.state.data.calendar ?
                        (<OwlCarousel className="owl-theme calendar-carousel" {...this.state.options}>
                            {this.state.data.calendar.map(function (calendars, index) {
                                var month = calendars.month;
                                return (
                                    <div key={index} className="luxury-grid">
                                        <div className="month-name">
                                            <div className="item" style={{ color: `#${mainColor}` }}>
                                                {selectMonth(month)}
                                            </div>
                                        </div>
                                        <div className="button-container">
                                            <button onClick={scrollLeft} id="days-left-btn"></button>
                                        </div>
                                        <div className="days-list">
                                            {calendars.days.map(function (days, index) {
                                                var day = days.day;
                                                var url = days.url;
                                                return (
                                                    <div key={index} className="item day-box">
                                                        <a href={url}>
                                                            {day}
                                                        </a>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div className="button-container">
                                            <button onClick={scrollRight} id="days-right-btn"></button>
                                        </div>
                                    </div>
                                )
                            })}
                        </OwlCarousel>)
                        :
                        null}
                </div>

                <div className="row" style={{ margin: "0" }}>
                    {this.state.data.events ?
                        (
                            <div className="events-container">
                                {this.state.data.events.map(function (event, index, array_events) {
                                    index++;
                                    var date = event.datepicker;
                                    var day = event.date;
                                    var day_name = event.week_day;
                                    var description = event.description;
                                    var time = event.time;
                                    var place = event.place;
                                    var placeId = event.id_place;
                                    var type = event.type;
                                    var typeId = event.id_type;
                                    var ticket = event.entry;
                                    var ticket_url = event.entry_ticket_url;
                                    var image = event.image;
                                    var color = event.type_color;
                                    var subgroup = event.subgroup;
                                    let jsonItem = JSON.stringify({ title: event.artists[0].name + ', ' + place + ', ' + day_name + ' ' + day, image: image, text: description.replace(/<[^>]*>?/gm, '').substring(0, 90) + '...' });
                                    //console.log(jsonItem);
                                    let readyUrl = btoa(unescape(encodeURIComponent(jsonItem)))

                                    return (
                                        <div className={`event-box place-${placeId} type-${typeId}`} id={"event-" + index} key={index}>
                                            {
                                                (
                                                    (event.subgroup) &&
                                                    ((index === 1) ||
                                                        (
                                                            (array_events[index - 2] !== undefined) &&
                                                            (array_events[index - 1].subgroup.id !== array_events[index - 2].subgroup.id)
                                                        ))
                                                )
                                                    ? (<div className={`event-subgroup-name ` + ((index === 1) ? 'event-subgroup-name-first' : '')}> {subgroup.title}</div>)
                                                    : ''
                                            }
                                            <div className="event-time">
                                                <p className="date">{day}</p>
                                                <p className="day">{day_name}</p>
                                            </div>
                                            <div className="event-description" style={{ borderColor: color }}>
                                                <div className="row" style={{ margin: "0", position: "relative" }}>
                                                    <div className="col-sm-12 col-md-2 event-info">
                                                        <p className="event-hour">{time}</p>
                                                        <p dangerouslySetInnerHTML={{ __html: place }} />
                                                        {Array.isArray(event.types) && event.types.length > 0 ? (
                                                            event.types.map((typeItem, typeIndex) => (
                                                                <p key={typeIndex} dangerouslySetInnerHTML={{ __html: typeItem.type }} />
                                                            ))
                                                        ) : null}
                                                    </div>
                                                    <div className="col-sm-12 hidden-md hidden-lg hidden-xl mobile-photo" style={{ backgroundImage: 'url(' + image + ')' }}></div>
                                                    <div className="col-sm-12 col-md-3 artists">
                                                        <h3>{performers}:</h3>
                                                        {event.artists.map(function (artist, index) {
                                                            const url = artist.url;
                                                            const array = url.split("/");
                                                            const arrayPart = array[2];
                                                            const sameDomain = window.location.href.indexOf(arrayPart) > -1
                                                            return (
                                                                <div key={index} className="artist">
                                                                    {url.length ? sameDomain ? <a href={url}>{artist.name}</a> : <a target="_blank" href={url}>{artist.name}</a> : <span>{artist.name}</span>}
                                                                    <span className="title">{" " + artist.role}</span>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    <div className="col-sm-12 col-md-3 program">
                                                        <h3>{program}:</h3>
                                                        {event.program.map(function (program, index) {
                                                            const name = program.name;
                                                            const role = program.role;
                                                            const url = program.url;
                                                            const array = url.split("/");
                                                            const arrayPart = array[2];
                                                            const sameDomain = window.location.href.indexOf(arrayPart) > -1
                                                            return (
                                                                <div key={index} className={"program-item"}>
                                                                    {url.length ?
                                                                        sameDomain ? (
                                                                            <a href={url}>
                                                                                <div className="artist" dangerouslySetInnerHTML={{ __html: name }} />
                                                                            </a>
                                                                        ) : (
                                                                            <a href={url} target="_blank">
                                                                                <div className="artist" dangerouslySetInnerHTML={{ __html: name }} />
                                                                            </a>
                                                                        )
                                                                        : <span dangerouslySetInnerHTML={{ __html: name }} />
                                                                    }
                                                                    <div className="title" dangerouslySetInnerHTML={{ __html: role }} />
                                                                    <div>
                                                                        {program.compositions.map(function (composition, index) {
                                                                            var name = composition.name;
                                                                            return (
                                                                                <div key={index}>
                                                                                    <div className="title" dangerouslySetInnerHTML={{ __html: name }} />
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                    <div className="hidden-xs hidden-sm col-md-4 photo" style={{ backgroundImage: 'url(' + image + ')' }}></div>
                                                    <div className="col-sm-12 col-md-12 scrolled description" dangerouslySetInnerHTML={{ __html: description }} />
                                                </div>
                                                <div className="abs-addon">
                                                    {event.entry_ticket_url !== null && event.entry_ticket_url.indexOf("http") > -1 ?
                                                        (
                                                            <a href={ticket_url} className="free-btn buy-btn" target="_blank">{ticket}</a>
                                                        )
                                                        :
                                                        (
                                                            <button className="free-btn" type="button" name="button">{ticket}</button>
                                                        )}
                                                    <div className="social-wrapper">
                                                        <FacebookShareButton url={window.location.href + '/' + day.replace(/\./g, '-') + "?media=" + readyUrl}>
                                                            <FacebookIcon size={32} />
                                                        </FacebookShareButton>

                                                        <TwitterShareButton url={window.location.href + '/' + day.replace(/\./g, '-') + "?media=" + readyUrl}>
                                                            <TwitterIcon size={32} />
                                                        </TwitterShareButton>

                                                        <LinkedinShareButton url={window.location.href + '/' + day.replace(/\./g, '-') + "?media=" + readyUrl}>
                                                            <LinkedinIcon size={32} />
                                                        </LinkedinShareButton>
                                                    </div>
                                                    <button className="open-btn" id="show-desc-1" type="button" onClick={showDescription} style={{ backgroundImage: `url(${down_arrow})` }} name="button">{expand}</button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                        :
                        null
                    }
                </div>
            </div >
        );
    }
}
export default withRouter(View_type_25)



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_25/index.js